export const disneyRegisteredMark = () => {
  [
    ...document.querySelectorAll("h1"),
    ...document.querySelectorAll("h2"),
    ...document.querySelectorAll("h3"),
    ...document.querySelectorAll("h4"),
    ...document.querySelectorAll("h6"),
    ...document.querySelectorAll("p"),
    ...document.querySelectorAll("li"),
  ].forEach((el) => {
    if (
      el?.textContent?.includes("®") &&
      el?.querySelectorAll("a").length === 0
    ) {
      const parts = el.textContent.split("®");
      el.innerHTML = parts.join("<sup>®</sup>");

      el.classList.add("disney-registered-mark");
    }
  });
};
